import {
    FETCH_EWO_DISCRIPENCY_REQUEST,
    FETCH_EWO_DISCRIPENCY_SUCCESS,
    FETCH_EWO_DISCRIPENCY_FAILURE,
} from "../constants/EWODiscripencyConstants";

const initialState = {
    loading: false,
    data: [],
    error: null,
};

const EWODiscripencyReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_EWO_DISCRIPENCY_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_EWO_DISCRIPENCY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case FETCH_EWO_DISCRIPENCY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default EWODiscripencyReducer;
